<template>
  <section class="message__answer">
    <slot />
    <div v-html="formattedAnswers" />
  </section>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      require: true,
      default: ''
    }
  },
  computed: {
    formattedAnswers() {
      const answers = this.content.split('\\n')
      return answers.join('<br/>')
    }
  }
}
</script>

<style lang="scss">
.message__answer {
  max-width: max-content;
}
</style>
